<template>
  <div>
    <div class="shadow-card p-4">
      <div class="d-flex justify-content-between align-items-center">
        <a-button
          :style="{
            color: getPrimaryColor(),
            border: '1px solid ' + getPrimaryColor()
          }"
          class="py-1 pl-3 left-radius right-radius d-flex align-items-center back-button"
          @click="handleBackToButton"
        />
        <span :style="{ color: getPrimaryColor() }" class="mb-0">Back</span>
        </a-button>
        <span class="last-update"
          >Last Updated: {{ poll.post_time | updatedAt }}</span
        >
      </div>
      <div class="row p-2 mb-2">
        <img
          :src="
            poll.poll_attach
              ? poll.poll_attach.file
                ? poll.poll_attach.file
                : poll.poll_attach[0]
              : 'https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/no-image.png'
          "
          class="article-image"
        />
      </div>

      <div v-if="poll.tags" class="post__tags">
        <div
          v-for="(tag, index) in poll.tags.slice(0, 3)"
          :key="index"
          class="tags"
          :style="{
            color: getSecondaryColor(),
            background: getAlphaPrimaryColor()
          }"
        >
          #{{ tag }}
        </div>
        <div v-if="poll.tags.length > 3" class="popover-button">
          <a-popover placement="right">
            <template slot="content">
              <p
                v-for="(tag, index) in poll.tags.slice(3)"
                :key="index"
                :style="{
                  color: getSecondaryColor(),
                  background: getAlphaPrimaryColor()
                }"
              >
                #{{ tag }}
              </p>
            </template>
            <a-button
              :style="{
                background: getAlphaPrimaryColor(),
                color: getSecondaryColor(),
                padding: '2px'
              }"
              >+{{ poll.tags.length - 3 }}
            </a-button>
          </a-popover>
        </div>
      </div>

      <div v-if="showPercent" class="row p-2">
        <p class="title">{{ poll.poll_question }}</p>

        <div class="options" v-for="option in poll.choices" :key="option.id">
          <div class="option p-0">
            <div
              @click="choice = option.id"
              class="option"
              v-if="option.choice_vote"
              :style="{
                background: lighten(getPrimaryColor(), 50),
                maxWidth: option.choice_vote + '%'
              }"
            />
            <span class="poll-option">{{ option.poll_option }}</span>
            <span class="percentage"
              >{{ option.choice_vote.toFixed(0) }} %</span
            >
          </div>
        </div>

        <div class="d-flex justify-content-between w-100">
          <p :style="{ color: getPrimaryColor() }">
            Thank you for your Answer
          </p>
          <p>Total Votes : {{ poll.total_vote }}</p>
        </div>
      </div>
      <div v-else class="row p-2">
        <p class="title">{{ poll.poll_question }}</p>
        <div class="options" v-for="option in poll.choices" :key="option.id">
          <div
            @click="choice = option.id"
            :style="{
              background: choice === option.id ? getPrimaryColor() : '',
              color: choice === option.id ? 'white !important' : ''
            }"
            class="option"
          >
            {{ option.poll_option }}
          </div>
        </div>
        <div class="w-100 d-flex justify-content-center">
          <a-button
            :disabled="choice === null || disabled"
            :loading="loading"
            class="dovemed-button primary-button font-white "
            :style="{
              background: getPrimaryColor(),
              border: '1px solid' + getPrimaryColor()
            }"
            @click="submitPollResponse()"
            >Submit</a-button
          >
        </div>
      </div>
      <hr />
      <div class="d-flex justify-content-between align-items-center">
        <a
          class="mr-4 mb-1 share-button"
          @click="() => $refs.sharePostModal.show(poll, 5, 'Share Poll')"
          :style="{ color: getPrimaryColor() }"
          ><i
            :style="{ color: getPrimaryColor() }"
            class="fa fa-share-alt "
            aria-hidden="true"
          ></i>
          <span>SHARE</span></a
        >
        <span class="view-resource cp"
          >VIEW MORE RESOURCES<a-button
            class="pt-1 pb-1 ml-1 view-resource"
            shape="circle"
            :style="{ background: getPrimaryColor() }"
            @click="$router.push({ name: 'ResourceList' })"
            ><i
              class="fa fa-arrow-right font-white "
              aria-hidden="true"
            ></i></a-button
        ></span>
      </div>
    </div>
    <SharePostModal ref="sharePostModal" />
  </div>
</template>

<script>
import SharePostModal from "../../../Modals/SharePost";
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory";
import moment from "moment";
import { eventBus } from "../../../../main";

const ResourceRepository = RepositoryFactory.get("resource");
export default {
  name: "PollContent",
  props: {
    pollData: Object
  },
  data() {
    return {
      poll: null,
      loading: false,
      choice: null,
      showPercent: false,
      disabled: false
    };
  },
  components: {
    SharePostModal
  },

  created() {
    this.poll = this.pollData;
    console.log("home - resources - contents - poll");
  },
  filters: {
    updatedAt(date) {
      return moment(date).format("DD/MM/YYYY");
    }
  },

  methods: {
    handleBackToButton() {
      console.log(this.$router);
      if (this.pollData.user) {
        this.$router.push({ name: "ActivityHome" });
      } else {
        this.$router.push({ name: "ResourceList" });
      }
    },

    lighten(col, amt) {
      var usePound = false;

      if (col[0] == "#") {
        col = col.slice(1);
        usePound = true;
      }

      var num = parseInt(col, 16);

      var r = (num >> 16) + amt;

      if (r > 255) r = 255;
      else if (r < 0) r = 0;

      var b = ((num >> 8) & 0x00ff) + amt;

      if (b > 255) b = 255;
      else if (b < 0) b = 0;

      var g = (num & 0x0000ff) + amt;

      if (g > 255) g = 255;
      else if (g < 0) g = 0;

      return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    },
    submitPollResponse() {
      this.disabled = true;
      const data = {
        user_circle: this.currentCircle.id,
        user: this.authUser.user.id,
        poll: this.poll.id,
        choice: this.choice
      };
      ResourceRepository.postPoll(data)
        .then(res => {
          this.$notification.success({
            message: "Success",
            description: "Poll submitted successfully."
          });
          eventBus.$emit("refresh-resource-view");
          this.showPercent = true;
          ResourceRepository.getpoll(
            this.poll.id,
            1,
            5,
            this.currentCircle.id
          ).then(res => {
            console.log(res, "new poll data");
            this.poll = res.data.data.data[0];
          });
        })
        .catch(err => console.error(err));
    }
  }
};
</script>

<style lang="scss" scoped>
.back-button {
  font-size: 16px;
}
.last-update {
  font-size: 12px;
}
p.title {
  color: #333333;
  font-size: 20px;
  font-weight: bold;
}
.options {
  width: 100%;
  // height: auto !important;
  .option {
    position: relative;
    cursor: pointer;
    height: 55px;
    background-color: #f1f1f1;
    padding: 1rem;
    border-radius: 10px;
    margin-bottom: 1rem;
    .poll-option {
      position: absolute;
      left: 1rem;
      top: 1rem;
    }
    .percentage {
      position: absolute;
      right: 20px;
      top: 1rem;
    }
  }
}
.back-button {
  color: "white ";
}
@media screen and (max-width: 581px) {
  .share-button {
    font-size: 14px;
  }
  .last-update {
    font-size: 10px;
  }
  .back-button {
    font-size: 12px;
  }
  .view-resource {
    font-size: 14px;
  }
}
.post__tags {
  margin: 10px;
  display: flex;
  .tags {
    padding: 3px 16px;
    display: inline-block;
    font-weight: 700;
    font-size: 10px;
    margin: 5px;
  }
  .popover-button {
    margin: 5px;

    button {
      background: none;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/resources/contents/Poll.vue